import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  gap: 20px 13px;
  grid-template-columns: repeat(4, minmax(230px, 1fr));

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(3, minmax(275px, 1fr));
    gap: 20px 18px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px 17px;
    grid-template-columns: repeat(3, minmax(210px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 15px 13px;
    grid-template-columns: repeat(2, minmax(130px, 1fr));
  }
`;

export const BannerBox = styled.div`
  grid-column: 1/-1;
  width: calc(100% + 30px);
  margin-left: -15px;
`;
